import {StringMap} from "ra-core/src/i18n/TranslationMessages";

const enMessages: StringMap = {
};

export default enMessages;
